<div class="tga-soil-advice">
  <specific-form-header-section
    [title]="'TGA.Advice.Soil.title' | translate"
    [cropYear]="cropYear"
    [cropField]="cropField ?? undefined"
  ></specific-form-header-section>

  <div class="maps-container">
    <app-tga-map-card
      [mapData$]="biomassResource$"
      [mapTitle]="'TGA.Advice.Soil.maps.biomassMap'"
      [legendType]="'gradient'"
    ></app-tga-map-card>

    <app-tga-map-card
      [mapData$]="biomassPotatoResource$"
      [mapTitle]="'TGA.Advice.Soil.maps.biomassPotatoMap.title'"
      [legendType]="'gradient'"
    ></app-tga-map-card>
    <app-tga-map-card
      [mapData$]="elevationResource$"
      [mapTitle]="'TGA.Advice.Soil.maps.heightMap.title'"
      [legendType]="'gradient'"
    ></app-tga-map-card>

    <app-tga-map-card
      [mapData$]="soilResource$"
      [mapTitle]="'TGA.Advice.Soil.maps.soilMap'"
      [legendType]="'squares'"
    ></app-tga-map-card>
  </div>
  <app-risk-analysis [translationParams]="translationParams" [adviceLines]="soilAdvice()"></app-risk-analysis>
</div>
